(function () {
    "use strict";

    angular.module("sempraWebapp").controller("SavingsController", SavingsController);

    /** @ngInject */
    function SavingsController($scope, $state, $stateParams, $timeout, $translate, $filter, SavingsViewModel, savingsActions, userGroupActions, dialogsService, exportToCsv) {
        var vm = this;

        // Tab management
        vm.selectedTabIndex = $stateParams.tab || 0;

        // Users tab
        vm.savings = new SavingsViewModel();
        vm.isLoading = false;
        vm.savingsUsers = [];
        vm.searchFilter = '';
        vm.savingsForPrint = [];

        // Groups tab
        vm.isLoadingGroups = false;
        vm.savingsGroups = [];
        vm.groupSearchFilter = '';

        // Reports tab -- COMMENTED OUT
        // vm.isLoadingReports = false;
        // vm.reportsData = null;
        // vm.reportsDateFrom = new Date(new Date().setMonth(new Date().getMonth() - 1));
        // vm.reportsDateTo = new Date();
        // vm.reportsTimeFrame = 'DAILY';
        // vm.reportsTimeFrameList = ['HOURLY', 'DAILY', 'WEEKLY', 'MONTHLY'];
        // vm.currencyCode = '';

        // Report type dropdown -- COMMENTED OUT
        // vm.selectedReportType = 'revenueBySalesType';
        // vm.reportTypeOptions = [
        //     { key: 'revenueBySalesType', label: 'SAVINGS_REPORT_REVENUE_BY_SALES_TYPE' },
        //     { key: 'issuedCreditBySalesType', label: 'SAVINGS_REPORT_ISSUED_CREDIT_BY_SALES_TYPE' },
        //     { key: 'redeemedByDeviceType', label: 'SAVINGS_REPORT_REDEEMED_BY_DEVICE_TYPE' }
        // ];

        // Users tab functions
        vm.filterSavings = filterSavings;
        vm.printSavings = printSavings;
        vm.editSavings = editSavings;
        vm.deactivateSavings = deactivateSavings;
        vm.pageChanged = pageChanged;
        vm.sortChanged = sortChanged;

        // Groups tab functions
        vm.onTabChange = onTabChange;
        vm.filterGroups = filterGroups;
        vm.editGroup = editGroup;
        vm.createGroup = createGroup;
        vm.viewGroupDetails = viewGroupDetails;

        // Reports tab functions -- COMMENTED OUT
        // vm.loadReportsData = loadReportsData;
        // vm.exportReportsToCsv = exportReportsToCsv;
        // vm.getSelectedReportData = getSelectedReportData;
        // vm.getSelectedReportLabel = getSelectedReportLabel;

        // Initialize
        activate();

        function activate() {
            getSavingsUsers();
        }

        function onTabChange(tabIndex) {
            vm.selectedTabIndex = tabIndex;
            if (tabIndex === 1) {
                getSavingsGroups();
            }
            // COMMENTED OUT reports tab
            // else if (tabIndex === 2 && !vm.reportsData) {
            //     loadReportsData();
            // }
        }

        // Users functions
        function getSavingsUsers() {
            vm.isLoading = true;
            savingsActions.getSavingsUsers(
                vm.savings.page,
                vm.savings.pageSize,
                vm.savings.orderBy,
                vm.savings.order,
                vm.searchFilter
            ).then(function (data) {
                vm.savingsUsers = data.content || [];
                vm.savings.total = data.totalElements || 0;
                vm.isLoading = false;
            }).catch(function (error) {
                vm.isLoading = false;
                console.error('Error loading savings users:', error);
            });
        }

        function filterSavings() {
            vm.savings.page = 1;
            getSavingsUsers();
        }

        function pageChanged(page, limit) {
            vm.savings.paginationChanged(page, limit);
            getSavingsUsers();
        }

        function sortChanged(order) {
            vm.savings.sortChanged(order);
            getSavingsUsers();
        }

        function printSavings(savingsUser) {
            vm.savingsForPrint = [savingsUser];
            $timeout(function () {
                window.print();
            }, 100);
        }

        function editSavings(savingsUser) {
            $state.go('app.savingsEdit', { accountId: savingsUser.accountId });
        }

        function deactivateSavings(savingsUser) {
            dialogsService.showConfirmDialog(
                $translate.instant('SAVINGS_DEACTIVATE_TITLE'),
                $translate.instant('SAVINGS_DEACTIVATE_MESSAGE'),
                $translate.instant('YES'),
                $translate.instant('NO')
            ).then(function () {
                savingsActions.deactivateSavingsAccount(savingsUser.accountId).then(function () {
                    getSavingsUsers();
                }).catch(function (error) {
                    console.error('Error deactivating savings account:', error);
                });
            });
        }

        // Groups functions
        function getSavingsGroups() {
            vm.isLoadingGroups = true;
            userGroupActions.getSavingsUserGroups().then(function (data) {
                vm.savingsGroups = data || [];
                vm.isLoadingGroups = false;
            }).catch(function (error) {
                vm.isLoadingGroups = false;
                console.error('Error loading savings groups:', error);
            });
        }

        function filterGroups() {
            if (!vm.groupSearchFilter) {
                getSavingsGroups();
                return;
            }
            var filter = vm.groupSearchFilter.toLowerCase();
            userGroupActions.getSavingsUserGroups().then(function (data) {
                var allGroups = data || [];
                vm.savingsGroups = allGroups.filter(function (group) {
                    return group.name.toLowerCase().indexOf(filter) !== -1 ||
                           (group.description && group.description.toLowerCase().indexOf(filter) !== -1);
                });
            });
        }

        function editGroup(group) {
            $state.go('app.savingsGroupEdit', { id: group.id });
        }

        function createGroup() {
            $state.go('app.savingsGroupCreate');
        }

        function viewGroupDetails(group) {
            $state.go('app.savingsGroupDetails', { groupId: group.id });
        }

        // Reports functions -- COMMENTED OUT
        // function loadReportsData() {
        //     vm.isLoadingReports = true;
            
        //     var dateFrom = $filter('date')(vm.reportsDateFrom, 'yyyy-MM-dd');
        //     var dateTo = $filter('date')(vm.reportsDateTo, 'yyyy-MM-dd');
            
        //     savingsActions.getSavingsReports(dateFrom, dateTo, vm.reportsTimeFrame).then(function (data) {
        //         vm.reportsData = processReportsData(data);
        //         vm.isLoadingReports = false;
        //     }).catch(function (error) {
        //         vm.isLoadingReports = false;
        //         console.error('Error loading savings reports:', error);
        //     });
        // }

        // function processReportsData(data) {
        //     if (!data) {
        //         return null;
        //     }

        //     var revenueGroupNames = ['SAVINGS_SALE_TYPE_REGULAR', 'SAVINGS_SALE_TYPE_POSTPAID'];
        //     var deviceTypeNames = data.redeemedByDeviceType ? Object.keys(data.redeemedByDeviceType) : [];

        //     return {
        //         revenueBySalesType: {
        //             items: [
        //                 { name: 'SAVINGS_SALE_TYPE_REGULAR', amount: data.revenueByRegular || 0 },
        //                 { name: 'SAVINGS_SALE_TYPE_POSTPAID', amount: data.revenueByPostpaid || 0 }
        //             ],
        //             total: (data.revenueByRegular || 0) + (data.revenueByPostpaid || 0),
        //             chartData: buildLineChartData(data.revenueTimeSeries, revenueGroupNames)
        //         },
        //         issuedCreditBySalesType: {
        //             items: [
        //                 { name: 'SAVINGS_SALE_TYPE_REGULAR', amount: data.issuedCreditByRegular || 0 },
        //                 { name: 'SAVINGS_SALE_TYPE_POSTPAID', amount: data.issuedCreditByPostpaid || 0 }
        //             ],
        //             total: (data.issuedCreditByRegular || 0) + (data.issuedCreditByPostpaid || 0),
        //             chartData: buildLineChartData(data.issuedCreditTimeSeries, revenueGroupNames)
        //         },
        //         redeemedByDeviceType: buildRedeemedByDeviceTypeData(data.redeemedByDeviceType, data.redeemedTimeSeries)
        //     };
        // }

        // function buildRedeemedByDeviceTypeData(redeemedByDeviceType, timeSeries) {
        //     var items = [];
        //     var total = 0;
        //     var deviceTypeNames = [];

        //     if (redeemedByDeviceType) {
        //         Object.keys(redeemedByDeviceType).forEach(function(deviceType) {
        //             var amount = redeemedByDeviceType[deviceType] || 0;
        //             items.push({
        //                 name: 'DEVICE_TYPE_' + deviceType,
        //                 rawName: deviceType,
        //                 amount: amount
        //             });
        //             total += amount;
        //             deviceTypeNames.push('DEVICE_TYPE_' + deviceType);
        //         });
        //     }

        //     return {
        //         items: items,
        //         total: total,
        //         chartData: buildLineChartData(timeSeries, deviceTypeNames)
        //     };
        // }

        // function buildLineChartData(timeSeries, groupNames) {
        //     if (!timeSeries || timeSeries.length === 0 || !groupNames || groupNames.length === 0) {
        //         return null;
        //     }

        //     var translatedNames = groupNames.map(function(name) {
        //         return $translate.instant(name);
        //     });

        //     var groupsData = timeSeries.map(function(item) {
        //         return {
        //             groupValue: item.date,
        //             values: item.values || []
        //         };
        //     });

        //     return {
        //         data: {
        //             groupNames: translatedNames,
        //             groupsData: groupsData,
        //             unit: vm.currencyCode
        //         },
        //         x: {
        //             type: 'timeseries',
        //             tick: {
        //                 culling: { max: 15 },
        //                 rotate: 60,
        //                 format: getTimeSeriesFormat()
        //             }
        //         }
        //     };
        // }

        // function getTimeSeriesFormat() {
        //     switch (vm.reportsTimeFrame) {
        //         case 'HOURLY':
        //             return '%d/%m %H:%M';
        //         case 'DAILY':
        //             return '%d/%m/%y';
        //         case 'WEEKLY':
        //             return '%d/%m/%y';
        //         case 'MONTHLY':
        //             return '%m/%Y';
        //         default:
        //             return '%d/%m/%y';
        //     }
        // }

        // function getSelectedReportData() {
        //     if (!vm.reportsData || !vm.selectedReportType) {
        //         return { items: [], total: 0, chartData: null };
        //     }
        //     return vm.reportsData[vm.selectedReportType] || { items: [], total: 0, chartData: null };
        // }

        // function getSelectedReportLabel() {
        //     var selected = vm.reportTypeOptions.find(function(opt) {
        //         return opt.key === vm.selectedReportType;
        //     });
        //     return selected ? selected.label : '';
        // }

        // function exportReportsToCsv() {
        //     if (!vm.reportsData) {
        //         return;
        //     }

        //     var csvData = [];
        //     var dateFrom = $filter('date')(vm.reportsDateFrom, 'dd-MM-yyyy');
        //     var dateTo = $filter('date')(vm.reportsDateTo, 'dd-MM-yyyy');

        //     // Revenue by Sales Type
        //     csvData.push({
        //         Section: $translate.instant('SAVINGS_REPORT_REVENUE_BY_SALES_TYPE'),
        //         Type: '',
        //         Amount: ''
        //     });
        //     vm.reportsData.revenueBySalesType.items.forEach(function(item) {
        //         csvData.push({
        //             Section: '',
        //             Type: $translate.instant(item.name),
        //             Amount: item.amount
        //         });
        //     });
        //     csvData.push({
        //         Section: '',
        //         Type: $translate.instant('TOTAL'),
        //         Amount: vm.reportsData.revenueBySalesType.total
        //     });
        //     csvData.push({ Section: '', Type: '', Amount: '' });

        //     // Issued Credit by Sales Type
        //     csvData.push({
        //         Section: $translate.instant('SAVINGS_REPORT_ISSUED_CREDIT_BY_SALES_TYPE'),
        //         Type: '',
        //         Amount: ''
        //     });
        //     vm.reportsData.issuedCreditBySalesType.items.forEach(function(item) {
        //         csvData.push({
        //             Section: '',
        //             Type: $translate.instant(item.name),
        //             Amount: item.amount
        //         });
        //     });
        //     csvData.push({
        //         Section: '',
        //         Type: $translate.instant('TOTAL'),
        //         Amount: vm.reportsData.issuedCreditBySalesType.total
        //     });
        //     csvData.push({ Section: '', Type: '', Amount: '' });

        //     // Redeemed by Device Type
        //     csvData.push({
        //         Section: $translate.instant('SAVINGS_REPORT_REDEEMED_BY_DEVICE_TYPE'),
        //         Type: '',
        //         Amount: ''
        //     });
        //     vm.reportsData.redeemedByDeviceType.items.forEach(function(item) {
        //         csvData.push({
        //             Section: '',
        //             Type: $translate.instant(item.name),
        //             Amount: item.amount
        //         });
        //     });
        //     csvData.push({
        //         Section: '',
        //         Type: $translate.instant('TOTAL'),
        //         Amount: vm.reportsData.redeemedByDeviceType.total
        //     });

        //     var fileName = 'Savings_Reports_' + dateFrom + '_' + dateTo + '.csv';
        //     exportToCsv.exportBasicArrayToCsv(csvData, fileName);
        // }
    }
})();
